import React, { Component } from "react";
import { withApollo } from "react-apollo";
import { Queries, Mutations } from "../../../../graphql";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Typography,
  Spin,
  Row,
  Col,
  Input,
  Table,
  Icon,
  Button,
  Form,
  Select,
  Collapse,
} from "antd";
import Container from "../../../../components/user/Container";
import { numberWithCommas } from "../../../../utils/number";
import { typeDataLink } from "../../../../utils/welfareList";
import { getToken, workforce, checkLinkURL, urlBenefit } from "../../../../utils/auth";
import axios from "axios";
import { apiKeyNews } from "../../../../utils/apiKey";

const { Text, Title } = Typography;
const { Option } = Select;
const { Panel } = Collapse;

class WelfareListDashboard extends Component {
  state = {
    loading: false,
    loadingFullpage: true,
    dropdownWelfareType: [
      // { value: "", label: "ทั้งหมด" },
      // { value: "Disater", label: "ช่วยเหลือประสบภัยพิบัติ" },
      // { value: "Scholarship", label: "เบิกค่าธรรมเนียมการศึกษา" },
    ],

    dataTemp: {
      rowTableId: "1",
      noTable: "202211-01",
      id: "00000",
      empCodeTable: "5590113",
      nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      departmentNameTable: "งานบริหารสวัสดิการ",
      moneyPaymentsReceiptTable: "85000",
      moneyPaymentsTable: "85000",
      welfareType: "studyPayment",
      statusTable: "อนุมัติ",
    },
    dataTalbe: [
      // {
      //   rowTableId: "1",
      //   noTable: "202211-01",
      //   noDocTable: "00000",
      //   empCodeTable: "5590113",
      //   nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      //   departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      //   departmentNameTable: "งานบริหารสวัสดิการ",
      //   moneyPaymentsReceiptTable: "85000",
      //   moneyPaymentsTable: "85000",
      //   typeTable: "studyPayment",
      //   statusTable: "อนุมัติ",
      // },
      // {
      //   rowTableId: "1",
      //   noTable: "202211-01",
      //   noDocTable: "11111",
      //   empCodeTable: "5590113",
      //   nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      //   departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      //   departmentNameTable: "งานบริหารสวัสดิการ",
      //   moneyPaymentsReceiptTable: "85000",
      //   moneyPaymentsTable: "85000",
      //   typeTable: "paymentVictim",
      //   statusTable: "อนุมัติ",
      // },
      // {
      //   rowTableId: "1",
      //   noTable: "202211-01",
      //   noDocTable: "22222",
      //   empCodeTable: "5590113",
      //   nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      //   departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      //   departmentNameTable: "งานบริหารสวัสดิการ",
      //   moneyPaymentsReceiptTable: "85000",
      //   moneyPaymentsTable: "85000",
      //   typeTable: "hiv",
      //   statusTable: "ไม่อนุมัติ",
      // },
      // {
      //   rowTableId: "1",
      //   noTable: "202211-01",
      //   noDocTable: "33333",
      //   empCodeTable: "5590113",
      //   nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      //   departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      //   departmentNameTable: "งานบริหารสวัสดิการ",
      //   moneyPaymentsReceiptTable: "85000",
      //   moneyPaymentsTable: "85000",
      //   typeTable: "accident",
      //   statusTable: "อนุมัติ",
      // },
      // {
      //   rowTableId: "1",
      //   noTable: "202211-01",
      //   noDocTable: "44444",
      //   empCodeTable: "5590113",
      //   nameTable: "นางสาวกฐฟอ  กกงฬมปัขิ",
      //   orgTable: "ศูนย์บริการโลหิตแห่งชาติ",
      //   departmentTable: "ศูนย์บริการโลหิตแห่งชาติ-ฝ่ายจัดซื้อและพัสดุ",
      //   departmentNameTable: "งานบริหารสวัสดิการ",
      //   moneyPaymentsReceiptTable: "85000",
      //   moneyPaymentsTable: "85000",
      //   typeTable: "indemnity",
      //   statusTable: "อนุมัติ",
      // },
    ],
    columns: [
      {
        title: "เลขที่สารบรรณ",
        dataIndex: "refDocument",
        align: "center",
        render: (item, record, index) => <span>{item ?? '-'}</span>,
      },
      {
        title: "เลขที่เอกสาร",
        dataIndex: "documentNo",
        align: "center",
        render: (item, record, index) => <span>{item ?? '-'}</span>,
      },
      // {
      //   title: "ชื่อ - นามสกุล",
      //   dataIndex: "empName",
      //   align: "center",
      //   render: (item, record, index) => (
      //     <div align="left">
      //       <span>{item}</span>
      //     </div>
      //   ),
      // },
      // {
      //   title: "สำนัก",
      //   dataIndex: "orgName",
      //   width: "150px",
      //   render: (item, record, index) => <span>{item}</span>,
      // },
      // {
      //   title: "ฝ่าย",
      //   dataIndex: "diviName",
      //   render: (item, record, index) => <span>{item}</span>,
      // },
      // {
      //   title: "หน่วยงาน",
      //   dataIndex: "deptName",
      //   align: "center",
      //   render: (item, record, index) => <span>{item}</span>,
      // },
      {
        title: "ประเภทสวัสดิการ",
        dataIndex: "welfareTypeName",
        align: "center",
        render: (item, record, index) => <span>{item ?? '-'}</span>,
      },
      {
        title: "รายละเอียดการเบิก",
        dataIndex: "welfareDetail",
        align: "center",
        render: (item, record, index) => <span>{item ?? '-'}</span>,
      },
      {
        title: "จำนวนเงินเบิกตามระเบียบ",
        dataIndex: "totalWithdraw",
        align: "center",
        render: (item, record, index) => <span>{ item ? numberWithCommas(item) : '-'}</span>,
      },
      {
        title: "จำนวนเงินที่ได้รับอนุมัติ",
        dataIndex: "totalCurrentWithdraw",
        align: "center",
        render: (item, record, index) => <span>{item ? numberWithCommas(item) : '-'}</span>,
      },
      {
        title: "สถานะเอกสาร",
        dataIndex: "welfareStatusName",
        align: "center",
        render: (item, record, index) => <span>{item ?? '-'}</span>,
      },
      {
        title: "จัดการ",
        dataIndex: "7",
        align: "center",
        width: 100,
        fixed: "right",
        render: (item, record, index) => {
          return (
            <>
              <Link
                to={{
                  pathname:
                    "welfareList/form/" +
                    typeDataLink(record.welfareType) +
                    "/" +
                    record.id,
                  state: {
                    isApproveMode: false,
                  },
                }}
              >
                <Icon type="eye" className="mr-2" style={{ color: "#000" }} />
              </Link>
            </>
          );
        },
      },
    ],
    pageData: {
      page: 1,
      pageSize: 10,
    },
    pagination: {
      total: 10,
    },
    dataTalbeTotalAll: 0,
    preLoadSubmit: false,
    formValue: null,
    loginPerson: null,
    employeeCodes: null,
    dropDownlearningType: [],
    dropDownCategory: [],
  };

  checkStatusForm = (status) => {
    let statusShow = this.state.dropDownTypelearningStatus.filter((detail) => {
      return detail.label === status;
    });

    //  return
  };

  fetchProfile = async () => {
    try {
      const { client } = this.props;
      const { data } = await client.query({
        query: Queries.fetchProfile,
      });

      await this.setState({
        loginPerson: data.fetchProfile,
        loadingFullpage: false,
        employeeCodes: data.fetchProfile.employeeCodes[0],
      });
      // return data.fetchProfile

      // console.log('data.fetchProfile', data.fetchProfile)
      // await this.fetchListLearningESS()
      // console.log("FETCH PROFILE:", data.fetchProfile);
      // console.log("FETCH emp:", data.fetchProfile.employeeCodes[0]);
    } catch (e) {}
  };

  paginationChange = async (e) => {
    const { formValue, empCode, valueSearch } = this.state;
    const { form, afterSubmit, client } = this.props;
    // await e.preventDefault()

    // console.log("pagination e",e)
    // console.log("pagination values",values)
    let page = 0;
    if (e.current === 1) {
      page = 1;
    } else {
      page = e.current;
      //+ "0";
    }

    await this.setState({
      pageData: {
        page: parseInt(page),
        pageSize: 10,
      },
    });
    await this.setState({
      pageData: {
        page: parseInt(page),
        pageSize: 10,
      },
      currentPage: e.current,
    });

    // await this.fetchListPost()
    if (valueSearch) {
      // console.log("paginationChange formvalue!!", values);
      await this.listBenefitForStaffSearch();
    } else {
      await this.listBenefitForStaff();
    }
  };
  listBenefitForStaff = async () => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, employeeCodes, pageData, dataTemp } = this.state;

    await this.setState({
      loading: true,
    });

    // let searchKeyword ={
    //    empCode :loginPerson.employeeCodes[0],
    // }
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    let config = {
      headers,
      params: {
        ...pageData,
        //empCode: "5640056" //employeeCodes
        empCode: employeeCodes, //employeeCodes
      },
    };


    axios

    .get(
      `${urlBenefit()}disaster/listBenefitForStaff`,
      config
    )
      // .get(
      //   `${urlBenefit()}disaster/listBenefitForStaff`,
      //   {
      //     params: {
      //       ...pageData,
      //       //empCode: "5640056" //employeeCodes
      //       empCode: employeeCodes, //employeeCodes
      //     },
      //   },
      //   {
      //     headers: headers,
      //   }
      // )
      .then(async (response) => {
        console.log("response.data listBenefitForStaff", response.data);
        //response.data.welfareList.push(dataTemp)
        await this.setState({
          dataTalbe: response.data.welfareList,
          dataTalbeTotalAll: response.data.count,
          loadingFullpage: false,
          loading: false,
          pagination: {
            total: response.data.count,
          },
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  listBenefitForStaffSearch = async (e) => {
    const { token } = getToken();
    const { form, afterSubmit, client } = this.props;
    const { page, pageSize, employeeCodes, pageData, valueSearch } = this.state;

    //await e.preventDefault();
    form.validateFields(async (err, values) => {
      console.log("listBenefitForStaffSearch", values);
      const API_DEVICE_KEY = atob(apiKeyNews());

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apiKey: API_DEVICE_KEY,
      };

      let config = {
        headers,
        params: {
          empCode: employeeCodes, //employeeCodes
          // ...values,
          ...valueSearch,
          ...pageData,
        },
      };
  
  
      axios
      .get(
        `${urlBenefit()}disaster/listBenefitForStaff`,
        config
      )
      // axios
      //   .get(
      //     `${urlBenefit()}disaster/listBenefitForStaff`,
      //     {
      //       params: {
      //         empCode: employeeCodes, //employeeCodes
      //         // ...values,
      //         ...valueSearch,
      //         ...pageData,
      //       },
      //     },
      //     {
      //       headers: headers,
      //     }
      //   )
        .then(async (response) => {
          console.log("response.data", response.data);
          await this.setState({
            dataTalbe: response.data.welfareList,
            dataTalbeTotalAll: response.data.count,
            loadingFullpage: false,
            loading: false,
            //currentPage: 1,
          });
        })
        .catch((error) => console.error(`Error: ${error}`));
    });
  };

  listBenefitForStaffSearchPagi = async (e) => {
    const { token } = getToken();
    const { form, afterSubmit, client } = this.props;
    const { page, pageSize, employeeCodes, pageData } = this.state;

    await e.preventDefault();
    form.validateFields(async (err, values) => {
      console.log("listBenefitForStaffSearch", values);
      const API_DEVICE_KEY = atob(apiKeyNews());

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        apiKey: API_DEVICE_KEY,
      };

      await this.setState({
        valueSearch: values,
        loading: true,
      });

      let config = {
        headers,
        params: {
          empCode: employeeCodes, //employeeCodes
          ...values,
          page: 1,
          pageSize: 10,
        },
      };
  
  
      axios
      .get(
        `${urlBenefit()}disaster/listBenefitForStaff`,
        config
      )

      // axios
      //   .get(
      //     `${urlBenefit()}disaster/listBenefitForStaff`,
      //     {
      //       params: {
      //         empCode: employeeCodes, //employeeCodes
      //         ...values,
      //         page: 1,
      //         pageSize: 10,
      //       },
      //     },
      //     {
      //       headers: headers,
      //     }
      //   )
        .then(async (response) => {
          console.log("response.data", response.data);
          await this.setState({
            dataTalbe: response.data.welfareList,
            dataTalbeTotalAll: response.data.count,
            loadingFullpage: false,
            loading: false,
            currentPage: 1,
            pagination: {
              total: response.data.count,
            },
          });
        })
        .catch((error) => console.error(`Error: ${error}`));
    });
  };

  fetchListLearningESS = async () => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, employeeCodes, pageData } = this.state;

    await this.setState({
      loading: true,
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };
    console.log("pageData", pageData);

    axios
      .post(
        `${workforce()}/fetchListLearningESS/`,
        {
          // Authorization: token,
          // apiKey: API_DEVICE_KEY,
          args: {
            ...pageData,
            empCode: employeeCodes,
            // empCode:"415023",
            // searchKeyword: {
            //    courseName: "",
            //    categoryId:"",
            //    learningType:"",
            //    learningStatus:""
            // }
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        await this.setState({
          dataTalbe: response.data.data.data,
          dataTalbeTotalAll: response.data.data.total,
          loadingFullpage: false,
          loading: false,
          pagination: {
            total: response.data.data.total,
          },
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  fetchEnumByCondition = async (dropDownType) => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, employeeCodes } = this.state;

    await this.setState({
      loading: true,
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .post(
        `${workforce()}/fetchEnumByCondition/`,
        {
          condition: {
            where: {
              isDeleted: 0,
              enumType: dropDownType,
            },
            order: [["captionTh", "ASC"]],
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        let dropDownRetrue = [];
        await response.data.data.map((values, keys) => {
          dropDownRetrue.push({
            value: values.name,
            label: values.captionTh,
          });
        });

        await this.setState({
          // dropDownlearningType: dropDownRetrue
          ["dropDownType" + dropDownType]: dropDownRetrue,
          // dataTalbe: response.data.data.data,
          // loadingFullpage: false,
          // loading: false,
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  fetchListCategory = async () => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, employeeCodes } = this.state;

    await this.setState({
      loading: true,
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .post(
        `${workforce()}/fetchListCategory/`,
        {
          args: {
            page: 0,
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        let dropDownRetrue = [];
        await response.data.data.data.map((values, keys) => {
          dropDownRetrue.push({
            value: values.id,
            label: values.categoryName,
          });
        });

        await this.setState({
          dropDownCategory: dropDownRetrue,
          // dataTalbe: response.data.data.data,
          // loadingFullpage: false,
          // loading: false,
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  clearInput = async () => {
    await this.setState({
      pageData: {
        page: 0,
        pageSize: 10,
        valueSearch: null,
      },
      currentPage: 1,
    });
    await this.props.form.resetFields();

    await this.listBenefitForStaff();
  };

  personnelHistoryReport = async () => {
    const { token } = getToken();
    const { client, location, match } = this.props;
    const { page, pageSize, employeeCodes, formValue } = this.state;

    await this.setState({
      loadingFullpage: true,
    });

    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .post(
        `${checkLinkURL()}/export/pdf/personnelHistoryReport`,
        {
          args: {
            page: 0,
            pageSize: 10,
            empCode: employeeCodes,
            searchKeyword: {
              courseName: formValue?.courseName ? formValue?.courseName : "",
              learningType: formValue?.learningType
                ? formValue?.learningType
                : "",
              subType: formValue?.subType ? formValue?.subType : "",
              learningStatus: formValue?.learningStatus
                ? formValue?.learningStatus
                : "",
              categoryId: formValue?.categoryId ? formValue?.categoryId : "",
            },
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        const link = document.createElement("a");
        link.href = `data:application/pdf;base64,${response.data.data.base64}`;
        link.setAttribute("download", `รายงานประวัติการพัฒนาบุคลากร.pdf`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        await this.setState({
          loadingFullpage: false,
        });
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  geteDropdownDisasterType = async () => {
    const { token } = getToken();
    const { match } = this.props;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(
        `${urlBenefit()}dropdown/get_dropdown_by_type/`,
        {
          params: {
            dropdownType: "WDSStatus",
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response.data dropdown status", response.data);
        if (response.data) {
          const filterAllowShowStatus = response.data.filter(
            (item) => item.dropdownCode != "draft"
          );

          await this.setState({
            dropdownWelfareStatus: filterAllowShowStatus,
            //isEdit: response.data.data.approveStatus == "draft" ? true : false,
          });
          await this.setCondition(response.data);
        }
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  geteDropdownWelfareType = async () => {
    const { token } = getToken();
    const { match } = this.props;

    let eiei = [];
    const API_DEVICE_KEY = atob(apiKeyNews());

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      apiKey: API_DEVICE_KEY,
    };

    axios
      .get(
        `${urlBenefit()}dropdown/get_dropdown_by_type/`,
        {
          params: {
            dropdownType: "welfareType",
          },
        },
        {
          headers: headers,
        }
      )
      .then(async (response) => {
        console.log("response.data dropdown welfareType", response.data);
        if (response.data) {
        

          await this.setState({
            dropdownWelfareType: response.data,
            //isEdit: response.data.data.approveStatus == "draft" ? true : false,
          });
        }
      })
      .catch((error) => console.error(`Error: ${error}`));
  };

  async componentDidMount() {
    await this.fetchProfile();
    Promise.all([
      // this.fetchEnumByCondition("learningType"),
      // this.fetchEnumByCondition("learningStatus"),
      // this.fetchEnumByCondition("subTypeLearning"),
      // this.fetchListCategory(),
      this.geteDropdownDisasterType(),
      this.geteDropdownWelfareType(),
    ]).then(() => {
      this.listBenefitForStaff();
    });
  }

  render() {
    const { match } = this.props;
    const {
      currentPage,
      dataTalbe,
      columns,
      loading,
      pagination,
      valuesEndDate,
      disabledDateStart,
      endStartValues,
      preLoadSubmit,
      dropdownLeaveType,
      ddStartYear,
      ddEndYear,
      loadingFullpage,
      loginPerson,
      dropDownlearningType,
      dropDownCategory,
      dataTalbeTotalAll,
    } = this.state;
    const { getFieldDecorator } = this.props.form;
    console.log("dropDownlearningType", dataTalbe);
    return (
      <Container match={match}>
        <div className="breadcrumb-custom pb-3 mb-4">
          <span style={{ fontSize: "18px" }}>รายการเบิกเงินสวัสดิการ </span>
        </div>
        <Spin spinning={loadingFullpage} delay={0}>
          <div className="card-container" id="page-profile">
            <div className="px-5 py-1 card-bg-green">
              <div className="box-color-white ">
                <Collapse>
                  <Panel header="ค้นหา" key="1">
                    <Form
                      onSubmit={this.listBenefitForStaffSearchPagi}
                      className="px-4"
                    >
                      <Row
                        gutter={16}
                        type="flex"
                        justify="left"
                        align="top"
                        className="pb-2"
                      >
                        <Col xs={24} md={8}>
                          <Form.Item label={"เลขที่เอกสาร"} className="mb-0">
                            {getFieldDecorator("searchKeyword", {
                              initialValue: "",
                            })(<Input className="block-news" />)}
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                          <Form.Item label={"ประเภทสวัสดิการ"} className="mb-0">
                            {getFieldDecorator("welfareType", {
                              initialValue: "",
                            })(
                              <Select style={{ width: "100%" }}>
                                <Option value={""}>ทั้งหมด</Option>
                                {this.state.dropdownWelfareType &&
                                  this.state.dropdownWelfareType.map(
                                    (values, keys) => (
                                      <Option value={values.dropdownCode}>
                                        {values.dropdownNameTh}
                                      </Option>
                                    )
                                  )}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>

                        <Col xs={24} md={8}>
                          <Form.Item label={"สถานะ"} className="mb-0">
                            {getFieldDecorator("welfareStatus", {
                              initialValue: "",
                            })(
                              <Select style={{ width: "100%" }}>
                                <Option value="">ทั้งหมด</Option>
                                {this.state.dropdownWelfareStatus?.map(
                                  (valuesLabel, keys) => {
                                    return (
                                      <Option
                                        value={valuesLabel.dropdownCode}
                                        key={keys}
                                      >
                                        {valuesLabel.dropdownNameTh}
                                      </Option>
                                    );
                                  }
                                )}
                              </Select>
                            )}
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row
                        gutter={16}
                        type="flex"
                        justify="left"
                        align="top"
                        className=" mt-3"
                      >
                        <Col xs={24} md={24} align={"right"}>
                          <Button
                            type="primary"
                            className="mx-2 btn-white-red"
                            onClick={this.clearInput}
                          >
                            ล้างค่า
                          </Button>
                          <Button
                            type="primary"
                            id="btn-onsearch"
                            className="color-white"
                            htmlType="submit"
                            disabled={preLoadSubmit}
                          >
                            ค้นหา
                          </Button>
                          {preLoadSubmit && <Spin size="small" />}
                        </Col>
                      </Row>
                    </Form>
                  </Panel>
                </Collapse>
              </div>

              <div className="box-color-white ">
                <Row
                  gutter={16}
                  type="flex"
                  justify="left"
                  align="top"
                  className="mt-4"
                >
                  <Col xs={24} md={10} className="mb-3">
                    <strong className="color-red">
                      รายการเบิกเงินสวัสดิการ
                    </strong>
                  </Col>
                  <Col xs={24} md={14} align="right">
                    <Text>จำนวน : {dataTalbeTotalAll} รายการ </Text>
                    {/* <Button
                              className="btn-color-default color-white ml-3"
                              type="primary "
                              htmlType="submit"
                              onClick={this.personnelHistoryReport}
                           >
                              รายงานประวัติการพัฒนาบุคลากร
                           </Button> */}
                  </Col>
                  <Col xs={24} md={24} align={"center"}>
                    {
                      <Table
                        locale={{ emptyText: "ไม่พบข้อมูลรายการ" }}
                        dataSource={dataTalbe}
                        columns={columns}
                        // loading={loading}
                        scroll={{ x: 1300 }}
                        pagination={{
                          total: pagination.total,
                          current: currentPage,
                          showSizeChanger: false,
                        }}
                        //   onChange={this.paginationChange}
                        onChange={this.paginationChange}
                        // rowCount={dataTalbe.length}
                      />
                    }
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Spin>
      </Container>
    );
  }
}

WelfareListDashboard.defaultProps = {
  autoFocus: false,
};

WelfareListDashboard.propTypes = {
  afterSubmit: PropTypes.func,
  forgotLink: PropTypes.string,
  autoFocus: PropTypes.bool,
};

const WrappedWelfareListDashboard = Form.create()(WelfareListDashboard);

export default withApollo(WrappedWelfareListDashboard);
